export default __webpack_public_path__ + "static/media/icon-subsidio.4b806484.svg";